import { alertLabels } from "../../configuration/alert-labels/configuration/alert-labels/index.js";
const getStatusBasedErrorLabel = (status) => {
  switch (status) {
    case "RETURN_REQUESTED":
      return alertLabels.OrderReturnAlreadyRequestedFailure;
    case "NOT_RETURNABLE":
      return alertLabels.OrderNotReturnableFailure;
    default:
      return alertLabels.ReturnGeneralFailure;
  }
};
export {
  getStatusBasedErrorLabel
};
//# sourceMappingURL=get-status-based-error-label.js.map
